export default __webpack_public_path__ + "static/media/logo1.9a636399.gif";